const onFailure = (error) => ({
  message: 'Unidade de produto já cadastrada!',
  type: 'warning',
});

export default onFailure;
